import httpClient from './httpClient';
import { ENDPOINT_API } from '../../enums/endpoint';

const getStockRules = (params) => httpClient.get(`${ENDPOINT_API.STOCK_ROLES}`, { params });
const getStockRule = (id) => httpClient.get(`${ENDPOINT_API.STOCK_ROLES}/${id}`);
const postStockRule = (params) => httpClient.post(`${ENDPOINT_API.STOCK_ROLES}`, params);
const putStockRule = (id, params) => httpClient.put(`${ENDPOINT_API.STOCK_ROLES}/${id}`, params);
const deleteStockRule = (id) => httpClient.delete(`${ENDPOINT_API.STOCK_ROLES}/${id}`);

export {
	getStockRules,
	getStockRule,
	postStockRule,
	putStockRule,
	deleteStockRule,
};
